import secureApi from "../../utils/secureApi";

const withSport = (path: string, sport: string) =>
  `/api/v2/tournaments/${path}?sport=${encodeURIComponent(sport)}`;

export interface TournamentTestimonial {
  _id?: string;
  player: string;
  desc?: string;
  type: "text" | "video";
  link?: string;
  thumbnail?: string;
}

export async function listTournamentTestimonials(tournamentId: string, sport: string) {
  return secureApi.get(withSport(`testimonials/getAllTestimonials/${tournamentId}`, sport));
}

export async function createTournamentTestimonial(
  tournamentId: string,
  sport: string,
  payload: TournamentTestimonial
) {
  return secureApi.post(withSport(`testimonials/add/${tournamentId}`, sport), payload);
}

export async function listVideoGlimpses(tournamentId: string, sport: string) {
  return secureApi.get(withSport(`video-glimpses/${tournamentId}`, sport));
}
